module.exports = __webpack_public_path__ + "static/media/jacks.794481d5.jpg";